import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import AnnouncementBar from './components/AnnouncementBar';
import Header from './components/Header';
import Hero from './components/Hero';
import Schedule from './components/Schedule';
import AddTNL from './components/AddTNL';
import Champions from './components/Champions';
import TriviaChampion from './components/TriviaChampion';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';

import SchedulePage from './pages/SchedulePage';

import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import ProtectedRoute from './components/admin/ProtectedRoute';

function PublicSite() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div>
      <AnnouncementBar />
      <Header />
      <Hero />
      <section className="w-full bg-white py-14 px-6">
        <div className="max-w-3xl mx-auto">
          <p className="font-poppins text-dark text-sm sm:text-base leading-relaxed text-left">
            Looking for a fun night of trivia? Check the schedule below for one of our various
            locations to have a blast eating, drinking and answering questions. Our games are 8 to
            9 rounds. Simply join a team, or make a team, and build points. The game ends with a
            &ldquo;Final Jeopardy&rdquo; question.
          </p>
        </div>
      </section>
      <Schedule />
      <AddTNL />
      <Champions />
      <TriviaChampion />
      <Testimonials />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PublicSite />} />
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
